import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { CustomMuiThemeProvider } from 'theme/CustomMuiThemeProvider';

interface ComingSoonModalProps {
  open: boolean;
  onClose: () => void;
}

const ComingSoonModal = ({ open, onClose }: ComingSoonModalProps) => {
  const { t } = useTranslation();

  return (
    <CustomMuiThemeProvider>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'text.secondary',
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              gap: 1.5,
              py: 3,
            }}
          >
            <AutoAwesomeIcon sx={{ fontSize: 40, color: 'primary.main' }} />
            <Typography variant="h6" sx={{ color: 'text.primary' }}>
              {t('ai_analysis_coming_soon_title')}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {t('ai_analysis_coming_soon_description')}
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </CustomMuiThemeProvider>
  );
};

export default ComingSoonModal;
